/**
 * CrewInline — the crew chip on an outline row. Replaced RasciInline when RASCI was retired
 * (docs/FLOW_RECONCILIATION_PLAN.md, 2026-09-02).
 *
 * Shows "CFW101 · Sara Z. · Emilio M." when the milestone/thread is in the air, and NOTHING when
 * it is queued or landed — a queued milestone has no owner, by design, and an empty chip saying
 * "Unassigned" would just invite someone to assign it here. Assignment happens on the Flight Board
 * only; clicking the chip takes a tower operator there (everyone else just reads it).
 *
 * Reads frontend/src/outline/crew.js's shared index; the row re-renders on the outline-render the
 * index dispatches when it loads or changes, so no local state is needed.
 */

import { ctx } from '../outline/ctx.js'
import { hasModule, isSeatLoaded } from '../services/tenancy.js'
import { crewForMilestone, crewForThread, crewLabel } from '../outline/crew.js'

export default function CrewInline({ kind = 'milestone', id, style }) {
  const flight = kind === 'thread' ? crewForThread(id) : crewForMilestone(id)
  if (!flight) return null

  const canOpenBoard = isSeatLoaded() && (hasModule('workload') || hasModule('admin'))
  const names = (flight.crew || []).map(c => c.name).filter(Boolean)
  const title = (flight.kind === 'squadron' ? 'Squadron ' : 'Flight ') + flight.flightNumber +
    (names.length ? ' — crew: ' + names.join(', ') : ' — no crew yet') +
    (canOpenBoard ? '\nOpen the Flight Board' : '')

  function openBoard(e) {
    e.stopPropagation()
    if (!canOpenBoard) return
    if (ctx.closeAllWorkspaces) ctx.closeAllWorkspaces()
    window.dispatchEvent(new CustomEvent('open-team'))
  }

  return (
    <span
      className={'wf-crew-inline' + (canOpenBoard ? ' wf-crew-inline--link' : '')}
      title={title}
      onClick={openBoard}
      style={style}
    >
      <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{ flexShrink: 0 }}>
        <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
      </svg>
      {crewLabel(flight)}
    </span>
  )
}
